export const DIVIDED_BY_IMAGE_LAYOUT_CHILDREN_MOBILE_MIN_HEIGHT = "70vh";
export const DIVIDED_BY_IMAGE_LAYOUT_IMAGE_MOBILE_MAX_HEIGHT = "30vh";
export const DESKTOP_BREAKPOINT = "1280px";
export const LARGE_DESKTOP_BREAKPOINT = "1920px";
export const MOBILE_BREAKPOINT = "992px";
